import React, { useState } from 'react';
import { NavLink } from 'react-router-dom';
import {
  Button,
  TableRow,
  TableCell,
  Typography,
  Icon,
  Tooltip,
} from '@safedns/skydns-ui-react-lib';

import Modal from './DeleteCollectionDialog';

import sprite from '../../icons/sprite.svg';

import { actionTableCellStyle } from '../../styles/tableStyles';

import {
  useGetUserQuery,
  useGetProfilesQuery,
  useDeleteCollectionMutation,
} from '../../services/ADapi';

const CollectionsListItem = ({
  id,
  priority,
  name,
  policy,
  users,
  dataposition,
  onDragStart,
  onDragOver,
  onDrop,
  onDragLeave,
  onChangePriority,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const {
    data: { user_id },
  } = useGetUserQuery();

  const { data: profilesList = [] } = useGetProfilesQuery(user_id);

  const modalStateHandler = () => {
    setIsModalOpen(!isModalOpen);
  };

  const [deleteCollection] = useDeleteCollectionMutation();

  const handleDeleteCollection = async () => {
    try {
      await deleteCollection({
        user_id,
        id,
      }).unwrap();
      modalStateHandler();
    } catch (error) {
      console.error('Error deleting collection:', error);
    }
  };

  return (
    <>
      <TableRow
        draggable
        data-position={dataposition}
        onDragStart={onDragStart}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onDragLeave={onDragLeave}
        onDragEnd={onChangePriority}
      >
        <TableCell scope="row">
          <Tooltip
            placement="right"
            label="Удерживайте значок и перетащите, чтобы изменить приоритет коллекции."
          >
            <Icon
              id="drag-n-drop"
              sprite={sprite}
              width={22}
              height={22}
              className="drag-icon"
            />
          </Tooltip>
        </TableCell>
        <TableCell>{priority}</TableCell>
        <TableCell>{name}</TableCell>
        <TableCell>
          {profilesList.map((profile) =>
            profile.id === policy ? (
              <Typography
                key={`profile-${profile.id}`}
                variant="body1"
                component="span"
              >
                {profile.name}
              </Typography>
            ) : (
              ''
            )
          )}
        </TableCell>
        <TableCell>{users}</TableCell>
        <TableCell sx={actionTableCellStyle}>
          <NavLink to={id.toString()}>
            <Button isIconButton variant="icon">
              <Icon id="edit" sprite={sprite} width={24} height={24} />
            </Button>
          </NavLink>
        </TableCell>
        <TableCell sx={actionTableCellStyle}>
          <Button isIconButton variant="icon" onClick={modalStateHandler}>
            <Icon id="remove" sprite={sprite} width={24} height={24} />
          </Button>
        </TableCell>
      </TableRow>
      {isModalOpen ? (
        <Modal
          isOpen={isModalOpen}
          name={name}
          modalStateHandler={modalStateHandler}
          onDelete={handleDeleteCollection}
        />
      ) : null}
    </>
  );
};

export default CollectionsListItem;
